module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a7206ec49a3fb9b19a4067296f879553.png";